const headers = {
  name: "Delivery Note",
  navigate: {
    path: [
      {
        name: "Delivery Note",
        path: "/app/sales/delivery-note",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;